
import { ProfessionData } from '../types/professionTypes';

export const pharmaceutique: ProfessionData = {
  title: "Pharmaceutique",
  slug: "pharmaceutique",
  description: "Gestion sécurisée des déchets pharmaceutiques et médicaux",
  icon: "Pills",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Médicaments périmés",
      description: "Produits pharmaceutiques non utilisés ou périmés",
      solutions: ["Collecte sécurisée", "Incinération haute température", "Traçabilité complète"],
      environmentalBenefit: "Prévention de la contamination des eaux et sols"
    },
    {
      type: "Emballages pharmaceutiques",
      description: "Flacons, blisters, cartons pharmaceutiques",
      solutions: ["Tri sélectif", "Recyclage spécialisé", "Décontamination"],
      environmentalBenefit: "Réduction des déchets d'emballage"
    },
    {
      type: "Matériel médical",
      description: "Seringues, équipements à usage unique, matériel de laboratoire",
      solutions: ["Collecte DASRI", "Traitement haute température", "Élimination sécurisée"],
      environmentalBenefit: "Prévention des risques sanitaires et environnementaux"
    }
  ],
  relatedProfessions: ["sante", "chimie", "laboratoire"]
};
